import { Component, input } from '@angular/core';
import { AlphaPipe } from '../pipes/color.pipe';
import { Pixel, Percent, Rem, Hex } from '../../utils/models/types';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-tag',
  standalone: true,
  imports: [AlphaPipe],
  template: `
    <span
      class="status_label"
      #view_selection_value
      [style.color]="color()"
      [style.background-color]="color() | alphaPipe: opacity()"
      [style.border-radius]="border_radius()"
      [style.font-size]="font_size()">
      {{ label() }}
      <ng-content></ng-content>
    </span>
  `,
  styles: [
    `
      .status_label {
        border-radius: 2px;
        text-align: center;
        white-space: nowrap;
        vertical-align: initial;
        padding: 8px 12px;
        cursor: pointer;
      }
    `,
  ],
})
export class TagComponent {
  label = input<string>();
  color = input<Hex>();
  font_size = input<'large' | 'larger' | 'medium' | 'small' | 'smaller' | 'inherit'>(
    'inherit'
  );
  border_radius = input<Pixel | Percent | Rem>('10rem');
  opacity = input<number>(0.1);
}
